import React from "react"
import YouTube from "react-youtube";
// import type { YouTubeProps } from "react-youtube";

interface PropsModalReviews { 
  videoID: any,
  close: any,
}


export const ModalReviews: React.FC<PropsModalReviews> = ({ videoID, close }) => {
    
    const opts = {
    height: '390',
    width: '640',
    playerVars: {
        // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
        },
    };

    return (
        <section className={`modal${!videoID ? ' hide' : ''}`}>
            <div className="modal__container modal__container--video">
                <span className="modal__close" onClick={() => close(false)}></span>
                {videoID &&
                    <YouTube className="iframe-container" videoId={videoID} opts={opts} />
                }
            </div>
        </section>
    )
}